<template>
    <catalog-complex-card
        :complex="complex"
        :is-slider="isSlider"
    ></catalog-complex-card>
</template>

<script>
import Swiper, {EffectFade, Navigation, Pagination} from "swiper";

export default {
    name: "CatalogComplexCardWrapper",
    props: {
        complex: {
            type: Object,
            default: null
        },
        isSlider: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        initSwiperImages() {
            let cardSliders = document.querySelectorAll(".card__slider");

            cardSliders.forEach((slider, index) => {
                if (slider.__swiper__) {
                    slider.__swiper__.destroy(true, true);
                }

                const swiper = new Swiper(slider, {
                    modules: [Pagination, EffectFade, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    breakpoints: {
                        320: {},
                        768: {
                            touchRatio: 0,
                            navigation: {
                                prevEl: ".card-button_prev",
                                nextEl: ".card-button_next"
                            }
                        }
                    },
                    on: {}
                });

                slider.__swiper__ = swiper;
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initSwiperImages();
        });
    }
}
</script>
